<template>
	<div class="experience">
		<!-- <div class="card-container"> -->
			<!-- <div class="row row-hubs">
				<div class="col-12">
					<div class="experience-header">
						<h2 class="merriweather-reg-26">Bien plus</h2>
						<h2 class="merriweather-reg-40">Qu’une simple nuit</h2>
						<p class="merriweather-light-24 text-center">Le Club Hortense vous ouvre les portes d’un monde où chaque instant devient un <span class="merriweather-light-italic-24">privilège</span></p>
					</div>
				</div>
			</div>
			<div class="row row-hubs pt-5 pb-5">
				<div class="row-grid">
					<div class="col-hub cursor-pointer" @click="goToGroup('/collections/hotel-escapade-gourmande')">
						<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPE%CC%81RIENCES+CULINAIRE.jpg" alt="Expérience culinaire" class="zoom-img">
						</div>
            <p class="raleway-bold-p16 pt-3 w-100">Expérience culinaire</p>
            <p class="raleway-reg-p15">Savourez les meilleures saveurs locales dans des lieux sélectionnés avec soin.</p>
					</div>
					<div class="col-hub cursor-pointer" @click="goToGroup('/collections/sejour-spa')">
						<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPE%CC%81RIENCES+BIEN-E%CC%82TRE.jpg" alt="Expérience bien-être" class="zoom-img">
						</div>
            <p class="raleway-bold-p16 pt-3 w-100">Expérience bien-être</p>
            <p class="raleway-reg-p15">Séjournez dans des hébergements d’exception, choisis pour votre confort.</p>
					</div>
					<div class="col-hub cursor-pointer" @click="goToGroup('/destination/France')">
						<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPERIENCES+AUTHENTIQUES+ET+LOCALES.jpg" alt="Expérience locale" class="zoom-img" >
						</div>
            <p class="raleway-bold-p16 pt-3 w-100">Expérience locale</p>
            <p class="raleway-reg-p15">Explorez facilement la région grâce à nos guides et carnets d’adresses exclusifs.</p>
					</div>
				</div>
			</div>
		</div> -->
    <div class="row experience-card-leave">
      <div class="d-flex flex-row align-items-center justify-content-between w-100">
        <div class="leave-left">
          <img src="../images/badge-member.png" alt="feuille gauche" class="img-leaf-left">
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center text-center">
          <p class="raleway-bold-h3">Rejoignez le Club Hortense et accédez à un monde de privilèges</p>
          <a class="hortense-btn-primary raleway-bold-p" @click="showModal = true" target="_blank">Devenir membre</a>
          <p class="raleway-reg-p15 pt-3 cursor-pointer text-underline" @click="goToGroup('https://www.hortense.green/le-club-hortense')">
            En savoir plus sur le Club Hortense
          </p>
        </div>
        <div class="leave-right">
          <img src="../images/badge-member.png" alt="feuille droite" class="img-leaf-right">
        </div>
      </div>
    </div>
    <Modalsignup v-if="showModal" @close="showModal = false"></Modalsignup>
	</div>
  
</template>

<script>
import Modalsignup from './modals/Modalsignup.vue';
	export default {
		name: 'ExperienceHomeNew',
    components: { Modalsignup },
		data() {
			return {
        showModal: false,
      };
		},
		methods: {
			goToGroup(url){
        window.open(url, '_blank');
      }
		},
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/experience" />
<style lang="scss" scoped>
.card-container {
  padding-left: 65px !important;
  padding-right: 65px !important;
}

.row-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 40px;
}
</style>
